import { useQuery } from 'react-query';
import { GetCommunityStrategy } from 'services/apiServices';
import { Errors, TCommunityStrategyResult } from 'types/ApiServicesTypes';

export default function useGetCommunityStrategy(strategyId?: number) {
  const objQuery = useQuery<TCommunityStrategyResult, Errors>(
    ['GetCommunityStrategy', strategyId],
    async () => {
      if (strategyId) return await GetCommunityStrategy(strategyId);
      else return {} as TCommunityStrategyResult;
    },
  );
  return objQuery;
} 